const EMAIL_REGEX = /^[^@]+[^.@]@[^@]+$/

export const validateEmail = (email: string): boolean => EMAIL_REGEX.test(email)
